<template>
    <draggable
        class="item-container"
        tag="ul"
        :list="list"
        :group="{ name: 'g1' }"
        :disabled="lock"
        ><li v-for="(item, index) in list" :key="index">
            <b-modal
                size="lg"
                v-model="item.show"
                id="bv-modal-example"
                hide-footer
                hide-header
                centered
                body-bg-variant="dark"
                body-text-variant="light"
                scrollable
                ><b-container fluid>
                    <div class="d-block text-center">
                        <h3>Bibliothèque d'icône</h3>
                        <div class="row">
                            <div class="col-lg-8">
                                <b-form-input
                                    placeholder="Rechercher"
                                    v-model="search"
                                ></b-form-input>
                            </div>
                            <div class="col-lg-4">
                                <b-form-select
                                    v-model="selectCollection"
                                    :options="collectionOption"
                                ></b-form-select>
                            </div>
                        </div>
                        <br />
                        <div class="row">
                            <b-form-group label="Filtre">
                                <b-form-checkbox-group
                                    id="checkbox-group-filtre"
                                    v-model="filtreSelected"
                                    :options="filtreOptions"
                                ></b-form-checkbox-group>
                            </b-form-group>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <vue-select-image
                                    id="my-table"
                                    :dataImages="imageFiles"
                                    @onselectimage="onSelectImage($event, item)"
                                    :h="50"
                                    :w="50"
                                ></vue-select-image>
                            </div>
                        </div>
                    </div>
                    <b-button
                        class="mt-3"
                        block
                        @click="$bvModal.hide('bv-modal-example')"
                        >Fermer</b-button
                    >
                </b-container>
            </b-modal>
            <div class="row">
                <div class="col-lg-6">
                    <div class="row">
                        <div class="col-lg-1" @click="toggle(item)">
                            <span v-if="item.children.length > 0">
                                <b-icon-Chevron-right
                                    font-scale="1"
                                    v-if="item.isOpen == false"
                                ></b-icon-Chevron-right>
                                <b-icon-Chevron-down
                                    font-scale="1"
                                    v-if="item.isOpen == true"
                                    variant="success"
                                ></b-icon-Chevron-down>
                            </span>
                        </div>
                        <div class="col-lg-1" v-if="lock == false">
                            <b-iconstack font-scale="2.30">
                                <b-icon
                                    stacked
                                    icon="arrows-move"
                                    style="color: #cccccc"
                                    scale="0.90"
                                ></b-icon>
                            </b-iconstack>
                        </div>
                        <div class="col-lg-5">
                            <b-form-input
                                v-model="item.name"
                                placeholder="Nouveau Menu"
                                v-on:keyup.enter="makeFolder(item)"
                            ></b-form-input>
                        </div>
                        <div class="col-lg-5" v-if="lock == true">
                            <div class="row">
                                <div class="col-lg-4">
                                    <b-form-select
                                        v-model="item.breadcrumb"
                                        :options="optionBreadCrumb"
                                    ></b-form-select>
                                </div>
                                <div class="col-lg-4">
                                    <b-form-select
                                        v-model="item.main"
                                        :options="optionMain"
                                    ></b-form-select>
                                </div>
                                <div class="col-lg-4">
                                    <b-form-select
                                        v-model="item.menuitem"
                                        :options="optionMenuItem"
                                    ></b-form-select>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-1" v-if="lock == false">
                            <b-icon-plus-circle-fill
                                variant="success"
                                font-scale="2"
                                v-on:click="makeFolder(item)"
                                v-if="
                                    item.children.length == 0 &&
                                        item.lock == false
                                "
                                >+</b-icon-plus-circle-fill
                            >
                            <b-icon-plus-circle
                                font-scale="2"
                                variant="success"
                                v-on:click="$emit('add-item', item)"
                                v-if="
                                    item.children.length > 0 &&
                                        item.lock == false
                                "
                                >+</b-icon-plus-circle
                            >
                            <b-icon-lock-fill
                                v-b-tooltip.hover
                                title="Vous avez atteint le nombre limite de menu possible"
                                font-scale="2"
                                variant="secondary"
                                v-if="item.lock == true"
                                >+</b-icon-lock-fill
                            >
                        </div>
                        <div class="col-lg-1" v-if="lock == false">
                            <b-icon-x-square
                                v-on:click="deleteMenu(index)"
                                variant="danger"
                                font-scale="2"
                            ></b-icon-x-square>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="row">
                        <div class="col-lg-2" v-if="lock == false">
                            <h4>Couleur</h4>
                        </div>
                        <div class="col-lg-1" v-if="lock == false">
                            <v-swatches
                                v-model="item.iconcolor"
                                v-if="item"
                                show-fallback
                                fallback-input-type="color"
                                basic
                                show-border
                            ></v-swatches>
                        </div>
                        <div class="col-lg-2">
                            <input
                                type="image"
                                v-if="item.icon && item.icon != 'autre'"
                                class="img-thumbnail backImg"
                                v-on:click="showImage(item)"
                                :src="'/img/icon/' + item.icon + '.svg'"
                            />
                            <b-button
                                v-on:click="showImage(item)"
                                v-if="!item.icon || item.icon == 'autre'"
                                variant="outline-success"
                                >Choisir Icone</b-button
                            >
                        </div>
                        <div class="col-lg-1" v-if="lock"><h4>Front</h4></div>
                        <div class="col-lg-1" v-if="lock == true">
                            <v-swatches
                                v-model="item.frontcolor"
                                v-if="item"
                                show-fallback
                                fallback-input-type="color"
                                popover-x="left"
                                text-basic
                            ></v-swatches>
                        </div>
                        <div class="col-lg-1" v-if="lock"><h4>Back</h4></div>
                        <div class="col-lg-1" v-if="lock == true">
                            <v-swatches
                                v-model="item.iconcolor"
                                v-if="item"
                                show-fallback
                                fallback-input-type="color"
                                popover-x="left"
                                text-basic
                            ></v-swatches>
                        </div>
                        <div class="col-lg-1" v-if="lock == true"></div>
                    </div>
                </div>
            </div>

            <br />
            <nested-draggable
                v-show="item.isOpen"
                v-if="item.isFolder"
                :list="item.children"
                :lock="lock"
                @make-folder="$emit('make-folder', $event)"
                @add-item="$emit('add-item', $event)"
                @check-level="$emit('check-level', $event)"
            />
        </li>
    </draggable>
</template>
<script>
import draggable from "vuedraggable";
import VSwatches from "vue-swatches";
const imageJs = require("../../core/image.json");
export default {
    name: "nested-draggable",
    props: {
        list: {
            required: true,
            type: Array
        },
        lock: {
            required: true,
            type: Boolean
        }
    },
    data: function() {
        return {
            isOpen: false,
            imageShow: false,
            imageFiles: [],
            search: "",
            seachTab: [],
            currentPage: 1,
            perPage: 0,
            isFolder: false,
            filtreSelected: [],
            filtreOptions: [
                {
                    text: "Activités",
                    value: "activites"
                },
                {
                    text: "Divers",
                    value: "divers"
                },
                {
                    text: "Hébergements",
                    value: "hebergements"
                },
                {
                    text: "Hiver",
                    value: "hiver"
                },
                {
                    text: "Météo",
                    value: "meteo"
                },
                {
                    text: "Nature",
                    value: "nature"
                },
                {
                    text: "Patrimoine",
                    value: "patrimoine"
                },
                {
                    text: "Restauration",
                    value: "restauration"
                }
            ],
            optionBreadCrumb: ["IconBreadcrumb", "SimpleBreadcrumb"],
            optionMain: ["SimpleListMenu", "FicheRando", "FicheServiceBase"],
            optionMenuItem: [
                "FirstMenuItem",
                "SimpleMenuItem",
                "IconMenuItem",
                "CityMenuItem",
                "ImageAndTextMenuItem",
                "RandoMenuItem",
                "SkiMenu"
            ],
            selectCollection: "stick",
            collectionOption: [
                {
                    text: "Base",
                    value: "base"
                },
                {
                    text: "Stick",
                    value: "stick"
                },
                {
                    text: "Edge",
                    value: "edge"
                }
            ]
        };
    },
    beforeMount() {
        let id = 0;
        imageJs.forEach(element => {
            if (element.completname.includes(this.selectCollection) == true) {
                this.imageFiles.push({
                    id: id,
                    src:
                        "/img/icon/" +
                        this.selectCollection +
                        "_" +
                        element.name +
                        ".svg",
                    alt: element.name
                });
                id++;
            }
        });
    },
    components: {
        draggable,
        VSwatches
    },
    watch: {
        search: [
            {
                handler: "searchChange"
            }
        ],
        currentPage: [
            {
                handler: "pageChange"
            }
        ],
        filtreSelected: [
            {
                handler: "filtreChange"
            }
        ],
        list: [
            {
                handler: "checkLevel"
            }
        ],
        selectCollection: [
            {
                handler: "changeCollection"
            }
        ]
    },
    methods: {
        toggle: function(item) {
            if (item.isFolder) {
                item.isOpen = !item.isOpen;
            }
        },
        makeFolder: function(item) {
            this.$emit("make-folder", item);
            this.isOpen = true;
            item.isFolder = true;
        },

        showImage: function(item) {
            item.show = true;
        },
        onSelectImage: async function(data, item) {
            this.imageSelected = data;

            item.icon = this.selectCollection + "_" + data.alt;
        },
        deleteMenu: function(index) {
            this.list.splice(index, 1);
        },
        searchChange: function() {
            let searchTab = [];
            let id = 0;
            let imageBase = [];
            this.imageFiles = [];
            imageJs.forEach(element => {
                if (
                    element.completname.includes(this.selectCollection) == true
                ) {
                    imageBase.push({
                        id: id,
                        src:
                            "/img/icon/" +
                            this.selectCollection +
                            "_" +
                            element.name +
                            ".svg",
                        alt: element.name
                    });
                    id++;
                }
            });
            imageBase.forEach(image => {
                let reg = this.search;
                var res = image.alt.match(reg);

                if (res != null) {
                    searchTab.push(image);
                }
            });

            if (searchTab != []) {
                searchTab.forEach(element => {
                    this.imageFiles.push(element);
                });
            }
        },
        filtreChange: function() {
            this.imageFiles = [];
            let id = 0;
            if (this.filtreSelected.length > 0) {
                imageJs.forEach(element => {
                    this.filtreSelected.forEach(filtre => {
                        if (
                            element.completname.includes(
                                this.selectCollection
                            ) == true &&
                            element.completname.includes(filtre)
                        ) {
                            this.imageFiles.push({
                                id: id,
                                src:
                                    "/img/icon/" +
                                    this.selectCollection +
                                    "_" +
                                    element.name +
                                    ".svg",
                                alt: element.name
                            });
                            id++;
                        }
                    });
                });
            } else {
                imageJs.forEach(element => {
                    if (
                        element.completname.includes(this.selectCollection) ==
                        true
                    ) {
                        this.imageFiles.push({
                            id: id,
                            src:
                                "/img/icon/" +
                                this.selectCollection +
                                "_" +
                                element.name +
                                ".svg",
                            alt: element.name
                        });
                        id++;
                    }
                });
            }
        },
        checkLevel: function() {
            this.$emit("check-level");
        },
        changeCollection: function() {
            this.imageFiles = [];
            let id = 0;
            imageJs.forEach(element => {
                if (
                    element.completname.includes(this.selectCollection) == true
                ) {
                    this.imageFiles.push({
                        id: id,
                        src:
                            "/img/icon/" +
                            this.selectCollection +
                            "_" +
                            element.name +
                            ".svg",
                        alt: element.name
                    });
                    id++;
                }
            });
        }
    }
};
</script>
<style scoped>
.dragArea {
    min-height: 50px;
    outline: 1px dashed;
}

.backImg {
    background-color: #01001e;
    width: 47px;
    height: 47px;
}
ul {
    padding-left: 4em;
    line-height: 1.5em;
    list-style-type: none;
}
.backImg {
    background-color: #01001e;
    width: 47px;
    height: 47px;
}
.page-item.active .page-link {
    background-color: red !important;
    border-color: red !important;
}
</style>
